"use client";
import EventGitex from "@/components/Events/EventGitex";

export default function EventGitexPage() {
  return <EventGitex />;
}
